// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/northern-operations-equipment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/northern-operations-equipment/northern-operations-equipment.js';

mount([g0]);
